module.exports = __webpack_public_path__ + "static/media/02.42101f66.jpg";